<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

      <!-- Login v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
           <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"
            width="100"
          />
        </b-link>

        <b-card-title class="mb-4" style="text-align: center;">
          Aplikasi Ujian
        </b-card-title>
       

        <!-- form -->
        <validation-observer
          ref="loginForm"
          #default="{invalid}"
          v-if="showLogin == 1"
        >
        <p>Silahkan login kedalam akun anda</p>
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent
          >

            <!-- email -->
            <b-form-group
              label-for="email"
              label="Email"
            >
              <validation-provider
                #default="{ errors }"
                name="Email"
                rules="required|email"
              >
                <b-form-input
                  id="email"
                  v-model="username"
                  name="login-email"
                  :state="errors.length > 0 ? false:null"
                  placeholder="ujian@online.com"
                  autofocus
                />
               <small class="text-danger">{{ errors[0] ? 'Silahkan isi email anda' : '' }}</small>
              </validation-provider>
            </b-form-group>

            <!-- password -->
            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="password">Kata Sandi</label>
                <b-link :to="{name:'auth-forgot-password'}">
                  <small>Lupa Sandi?</small>
                </b-link>
              </div>
              <validation-provider
                #default="{ errors }"
                name="Password"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid':null"
                >
                  <b-form-input
                    id="password"
                    v-model="password"
                    :type="passwordFieldType"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false:null"
                    name="login-password"
                    placeholder="Password"
                  />

                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
               <small class="text-danger">{{ errors[0] ? 'Silahkan isi password anda' : '' }}</small>
              </validation-provider>
            </b-form-group>

            <!-- <b-form-group
                label="Login Sebagai"
                label-for="login_sebagai"
              >
                <validation-provider
                  #default="{ errors }"
                  name="login sebagai"
                >
                  <v-select
                    id="login_sebagai"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    label="title"
                    :reduce="val => val.value"
                    :options="loginSebagaiOption.options"
                    v-model="login_sebagai"
                    placeholder="Pilih Login Sebagai"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group> -->

            <!-- checkbox -->
            <b-form-group>
              <b-form-checkbox
                id="remember-me"
                v-model="status"
                name="checkbox-1"
              >
                Ingat Saya
              </b-form-checkbox>
            </b-form-group>

            <!-- submit button -->
            <b-button
              variant="primary"
              type="submit"
              block
              :disabled="invalid"
              @click="login()"
            >
              Masuk
            </b-button>
          </b-form>
        </validation-observer>

        <!-- <b-card-text class="text-center mt-2">
          <span>Belum memiliki akun? </span>
          <b-link :to="{name:'auth-register'}">
            <span>Daftar akun</span>
          </b-link>
        </b-card-text> -->
        <b-card-text class="text-center mt-2">
          <b-link href="https://sso.ui.ac.id/cas/login?service=https%3A%2F%2Fbackend-ujian.portal-psikoui.com%2Fapi%2Fv1%2Fcas%2Flogin">
            <span>Masuk Menggunakan SSO</span>
          </b-link>
        </b-card-text>
     

        <div class="divider my-2">
          <div class="divider-text">
            atau
          </div>
        </div>

        <b-card-text class="text-center mt-2">
          <b-link href="#" @click="showLoginF()">
            <span>Masuk Email dan Password</span>
          </b-link>
        </b-card-text>
        <!-- social button -->
      
        <center v-if="loading == 1"><b-spinner label="Spinning"></b-spinner></center>
        <div>
          <b-modal id="bv-modal-reset-user" hide-footer>
            <template #modal-title>
              Reset Email dan Password default
            </template>
            <div class="d-block text-center mb-3 mt-3">
              <h5>Ganti email menggunakan email aktif anda.</h5>
              <h5>Perhatikan dengan baik email anda karena email akun ini hanya dapat diganti 1x.</h5>
            </div>
            <div>
               <b-form-group
                  label-for="email"
                  label="Email Aktif Anda"
                >
                  <b-form-input
                      id="email"
                      v-model="reset.email"
                      name="login-email"
                      placeholder="Email Baru"
                      autofocus
                    />
                </b-form-group>
                <b-form-group
                  label-for="password"
                  label="Password Anda"
                >
                  <b-input-group
                    class="input-group-merge"
                  >
                    <b-form-input
                        id="password"
                        v-model="reset.password"
                        :type="passwordFieldType"
                        class="form-control-merge"
                        name="login-password"
                        placeholder="Password Baru"
                      />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
            </div>
            <div class="d-flex justify-content-center">
              <b-spinner
              :variant="'dark'" v-if="loadingShow == true"
              ></b-spinner>
            </div>
            <div class="d-flex justify-content-center">
              <b-button class="mt-3 mr-1" variant="info" @click="simpanResetAkun()" :disabled="loadingShow == true">Simpan</b-button>
              <b-button class="mt-3" variant="danger" @click="$bvModal.hide('bv-modal-reset-user')" :disabled="loadingShow == true">Batal</b-button>
            </div>
          </b-modal>
        </div>
      </b-card>
      <!-- /Login v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BButton, BForm, BFormInput, BFormGroup, BCard, BLink, BCardTitle, BCardText, BInputGroup, BInputGroupAppend, BFormCheckbox, BImg, BSpinner,
} from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import router from '@/router'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  Authlogin,
  setToken,
  setRefreshToken,
} from '@/connection-api/authentication'
import {
  resetAkun,
  getTokenSso,
} from '@/connection-api/master'

export default {
  components: {
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    VuexyLogo,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
    BImg,
    vSelect,
    BSpinner,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      showLogin: 0,
      loading: 0,
      loadingShow: false,
      reset: {},
      username: '',
      password: '',
      status: '',
      login_sebagai: null,
      // validation rules
      required,
      email,
      sideImg: require('@/assets/images/logo/logo.png'),
      loginSebagaiOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Login Sebagai --' },
          { value: 'mahasiswa', title: 'Mahasiswa' },
          { value: 'penguji', title: 'Penguji' },
          { value: 'pembimbing', title: 'Pembimbing' },
          
        ],
      },
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/logo/logo.png')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    showLoginF() {
      if(this.showLogin == 1)
      {
        this.showLogin = 0
      } else {
        this.showLogin = 1
      }
    },
    simpanResetAkun()
    {
      this.loadingShow = true
      resetAkun(this.reset)
      .then(response => {
      if (response.data.success == true) {
        this.loadingShow = false
       this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: `Reset Akun`,
            icon: 'CoffeeIcon',
            variant: 'success',
            text: 'Anda telah berhasil reset akun Aplikasi Ujian. Silahkan login menggunakan kredensial baru anda.',
          },
        })
        this.$bvModal.hide('bv-modal-reset-user')
      } else {
        this.loadingShow = false
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: `Reset Akun`,
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: response.data.message,
          },
        })
        // this.$bvModal.hide('bv-modal-reset-user')
      }
      })
      .catch(error => console.log(error));
    },
    login() {
      this.loading = 1
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          Authlogin({
            email: this.username,
            password: this.password,
            application_token: this.applicationToken,
            query: router.currentRoute.query,
            token_firebase: localStorage.getItem('tokenFirebase'),
            login_sebagai: this.login_sebagai,
          })
            .then(response => {
              if (response.data.error) {
                this.loading = 0
                this.$swal({
                  title: 'Gagal!',
                  html: `${response.data.message}`,
                  icon: 'error',
                  customClass: {
                    confirmButton: 'btn btn-primary',
                  },
                  buttonsStyling: false,
                })
              } else {
                this.loading = 0
                if(response.data.reset == true)
                {
                  this.$bvModal.show('bv-modal-reset-user')
                  this.reset.token = response.data.token
                }

                const { member, urlCallback } = response.data.data
                setToken(response.data.data.accessToken)
                setRefreshToken(response.data.data.refreshToken)

                /// /////// TEMPORARY ACL SIMULATION ////////////////

                // baca value userData.roles
                // value-nya mungkin bisa  array of string atau hanya string
                // jadi perlu check if array
                // let userRole = ''
                // if (Array.isArray(member.roles)) {
                //   // ambil item pertama
                //   const test = member.roles[0]
                //   userRole = test
                // } else {
                //   userRole = member.roles
                // }

                localStorage.setItem('userData', JSON.stringify(member))
                this.$ability.update(member.ability)
                if (urlCallback === '') {
                  this.$router.push('/dashboard/analytics')
                    .then(() => {
                      this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: `Selamat Datang ${member.fullName || member.username}`,
                          icon: 'CoffeeIcon',
                          variant: 'success',
                          text: 'Anda telah berhasil masuk Aplikasi Ujian. Sekarang Anda bisa mulai menjelajah!',
                        },
                      })
                    })
                } else {
                  localStorage.setItem('urlCallback', urlCallback)
                  window.location.href = urlCallback
                }
              }
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
